<template>
  <div class="yuanbao-author-rule-wrap">
    <div class="hd">
      <span class="btn-close" @click="handleClosePage" />
    </div>
    <div class="bd">
      未完成授权协议签署，请重新签署
      <a class="btn" :href="url" rel="noopener noreferrer" target="_blank" @click="handleClosePage">确定</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HezuoAuthorRuleCenter',
  components: {
  },
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    handleClosePage() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss">
.yuanbao-author-rule-wrap {
  z-index: 30;
  position: relative;
  width: 400px;
  height: 167px;
  background: #000;
  color: #fff;
  border-radius: 12px;
  overflow: hidden;
  .btn-close {
    position: absolute;
    right: 8px;
    top: 8px;
    // width: 20px;
    // height: 20px;
    cursor: pointer;
    &:hover {
      &::before {
        background-position: -21px 0;
      }
    }
    &:active {
      &::before {
        background-position: -42px 0;
      }
    }
    &::before {
      content: '';
      display: inline-block;
      width: 21px;
      height: 21px;
      background: url('~@/assets/images/close.png') 0 0 no-repeat;
    }
  }
  .strong {
    color: #E88E01;
  }
}
.bd {
  margin-top: 52px;
  text-align: center;
}
.btn {
  display: block;
  user-select: none;
  cursor: pointer;
  margin: 20px auto;
  width: 240px;
  height: 40px;
  color: #333;
  text-align: center;
  line-height: 40px;
  background: #F4C000;
  border-radius: 8px;
}
</style>
